import { create_private_room } from './chat_utils';

export default class ChatAddRoom {
  constructor(opts) {
    this.user = opts.user;
    this.users_list = [...frappe.user.get_emails(), 'Administrator'];
    this.user_email = opts.user_email;
    this.chat_list = opts.chat_list;
    this.users_list = this.users_list.filter(function (user) {
      return user != opts.user_email;
    });
    this.setup();
  }

  async setup() {
    this.add_room_dialog = new frappe.ui.Dialog({
      title: __('New Chat Room'),
      fields: [
        {
          label: __('Room Type'),
          fieldname: 'type',
          fieldtype: 'Select',
          options: ['Group', 'Direct'],
          default: 'Group',
          onchange: () => {
            const type = this.add_room_dialog.get_value('type');
            const is_group = type === 'Group';
            this.add_room_dialog.set_df_property('room_name', 'reqd', is_group);
            this.add_room_dialog.set_df_property('users', 'reqd', is_group);
            this.add_room_dialog.set_df_property('user', 'reqd', !is_group);
          },
          reqd: true,
        },
        {
          label: __('Room Name'),
          fieldname: 'room_name',
          fieldtype: 'Data',
          depends_on: "eval:doc.type == 'Group'",
          reqd: true,
        },
        {
          label: __('Users'),
          fieldname: 'users',
          fieldtype: 'MultiSelectPills',
          options: this.users_list,
          depends_on: "eval:doc.type == 'Group'",
          reqd: true,
        },
        {
          label: __('User'),
          fieldname: 'user',
          fieldtype: 'Link',
          options: 'User',
          depends_on: "eval:doc.type == 'Direct'",
        },
      ],
      action: {
        primary: {
          label: __('Create'),
          onsubmit: (values) => {
            let users = this.add_room_dialog.fields_dict.users.get_values();
            let room_name = values.room_name;
            if (values.type === 'Direct') {
              users = [values.user];
              room_name = 'Direct Room';
            }
            this.handle_room_creation(room_name, users, values.type);
            this.add_room_dialog.hide();
          },
        },
      },
    });
  }

  show() {
    this.add_room_dialog.show();
  }

  async handle_room_creation(room_name, users, type) {
    try {
      const roomData = await create_private_room(room_name, users, type);
      if (roomData) {
        // Don't create new room UI if it's an existing direct chat
        if (!roomData.is_existing) {
          const profile = {
            room: roomData.name,
            room_name: roomData.room_name,
            room_type: roomData.type,
            user: this.user,
            user_email: this.user_email,
            is_admin: roomData.is_admin,
            members: roomData.members || [],
            last_message: '',
            last_date: new Date().toISOString(),
            opposite_person_email: type === 'Direct' ? users[0] : null
          };

          if (this.chat_list) {
            this.chat_list.create_new_room(profile);
          }
        }

        this.add_room_dialog.clear();
        frappe.show_alert({
          message: roomData.is_existing ? 
            __('Chat room already exists') : 
            __('Chat room created successfully'),
          indicator: roomData.is_existing ? 'blue' : 'green'
        });
      }
    } catch (error) {
      console.error('Error in room creation:', error);
      frappe.show_alert({
        message: __('Failed to create chat room'),
        indicator: 'red'
      });
    }
  }
}
